import { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import Button from "../../components/common/button/Button";
import { getApi } from "../../services/api/globalApi";
import { walletsTransactionColumns } from "../../constant/tablesColumns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { convertDate } from "../../utils/convertDate";
import { digitsThree } from "../../utils/price";
import UserReportsFilter from "./WalletsFilter";
import PaymentStatusModal from "./sub-components/paymentStatusModal/PaymentStatusModal";
import { useNavigate } from "react-router";

export default function WalletsTransaction() {
  const [walletTransactions, setWalletsTransactions] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [totalBalance, setTotalBalance] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [totalCommissions, setTotalCommissions] = useState(null);
  const [isCommissionFilter, setIsCommissionFilter] = useState(false);

  const { utils } = useSelector(utilsState);
  const navigate = useNavigate();

  const addTransaction = () => {
    navigate("/add-deposit");
  };

  const getWalletsTransactions = async (params) => {
    const path = "admin/wallets";
    try {
      const response = await getApi({ path, params: { ...params } });
      setWalletsTransactions(response?.data?.result.data);
      setPagination(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  const getWallet = async () => {
    const path = "admin/wallets/totalBalance";
    try {
      const response = await getApi({ path });
      console.log(response);
      setTotalBalance(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  const getUserBalance = async (userId, additionalParams = {}) => {
    const path = "admin/wallets/userBalance";
    try {
      const response = await getApi({ path, params: { user: userId, ...additionalParams } });
      setUserBalance(response?.data?.result);
    } catch (error) {
      console.log(error);
      setUserBalance(null);
    }
  };

  const getTotalCommissionsData = async (params) => {
    const path = "admin/wallets/totalCommissions";
    try {
      const response = await getApi({ path, params });
      const amount = response?.data?.result?.amount || 0;
      setTotalCommissions(amount);
    } catch (error) {
      console.log(error);
      setTotalCommissions(null);
    }
  };

  useEffect(() => {
    getWalletsTransactions({});
    getWallet();
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    
    if (newParams.user !== undefined) {
      if (newParams.user) {
        const balanceParams = {};
        if (allFilter.from) balanceParams.from = allFilter.from;
        if (allFilter.to) balanceParams.to = allFilter.to;
        if (allFilter.type) balanceParams.type = allFilter.type;
        if (allFilter.isCommission !== undefined) balanceParams.isCommission = allFilter.isCommission === "1";

        getUserBalance(newParams.user, balanceParams);
        if (allFilter.isCommission === "1") {
          getTotalCommissionsData(allFilter);
        }
      } else {
        setUserBalance(null);
        setTotalCommissions(null);
      }
    }
    
    if (newParams.from !== undefined || newParams.to !== undefined || newParams.type !== undefined) {
      if (allFilter.user) {
        const balanceParams = {};
        if (allFilter.from) balanceParams.from = allFilter.from;
        if (allFilter.to) balanceParams.to = allFilter.to;
        if (allFilter.type) balanceParams.type = allFilter.type;
        if (allFilter.isCommission !== undefined) balanceParams.isCommission = allFilter.isCommission === "1";

        getUserBalance(allFilter.user, balanceParams);
      }
      if (allFilter.isCommission === "1" && allFilter.user) {
        getTotalCommissionsData(allFilter);
      }
    }

    if (newParams.isCommission !== undefined) {
      const isCommission = newParams.isCommission === "1";
      setIsCommissionFilter(isCommission);
      if (isCommission && allFilter.user) {
        getTotalCommissionsData(allFilter);
      } else {
        setTotalCommissions(null);
      }
    }
    
    getWalletsTransactions(allFilter);
  };

  const data = [];

  walletTransactions?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      name: item?.user?.name,
      mobile: item?.user?.mobile,
      id: item._id,
      amount: digitsThree(item?.amount),
      paymentStatus: item.paymentStatus,
      faPaymentStatus: utils?.PAYMENT_STATUS[item.paymentStatus]?.name,
      type: item.type === "deposit" ? "واریز" : "برداشت",
      isCommission: item.isCommission ? "بله" : "خیر",
      date: convertDate(item?.createdAt),
    })
  );

  const paymentStatusRef = useRef();

  const [transactionData, setTransactionData] = useState(null);

  const chnagePaymentStatus = (data) => {
    setTransactionData(data);
    paymentStatusRef.current.showModal();
  };

  const editTransaction = (data) => {
    navigate(`/edit-transaction/${data._id}`);
  };

  return (
    <>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-6">
          <div className="bg-white dark:bg-gray-900 flex items-center gap-4 p-4 rounded-lg border border-gray-200 shadow-md">
            <img
              src={require("./../../assets/images/wallet.png")}
              alt="wallet"
              className="h-10 w-16 flex-shrink-0"
            />
            <div className="flex flex-col gap-1 dark:text-white min-w-0">
              <p className="text-sm text-gray-500 dark:text-gray-400">موجودی کل کیف پول</p>
              <p className="font-semibold text-lg truncate">{digitsThree(totalBalance)}</p>
            </div>
          </div>
          {userBalance !== null && !isCommissionFilter && (
            <div className="bg-white dark:bg-gray-900 flex items-center gap-4 p-4 rounded-lg border border-gray-200 shadow-md">
              <img
                src={require("./../../assets/images/wallet.png")}
                alt="wallet"
                className="h-10 w-16 flex-shrink-0"
              />
              <div className="flex flex-col gap-1 dark:text-white min-w-0">
                <p className="text-sm text-gray-500 dark:text-gray-400">موجودی کاربر انتخابی</p>
                <p className="font-semibold text-lg truncate">{digitsThree(userBalance)}</p>
              </div>
            </div>
          )}
          {totalCommissions !== null && isCommissionFilter && (
            <div className="bg-white dark:bg-gray-900 flex items-center gap-4 p-4 rounded-lg border border-gray-200 shadow-md">
              <img
                src={require("./../../assets/images/wallet.png")}
                alt="wallet"
                className="h-10 w-16 flex-shrink-0"
              />
              <div className="flex flex-col gap-1 dark:text-white min-w-0">
                <p className="text-sm text-gray-500 dark:text-gray-400">مجموع کمیسیون</p>
                <p className="font-semibold text-lg truncate">{digitsThree(totalCommissions)}</p>
              </div>
            </div>
          )}
        </div>

      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <div className="flex justify-between items-center mb-6 gap-4">
          <Title title={"لیست تراکنش ها"} />
          <Button
            onClick={addTransaction}
            text="ایجاد تراکنش"
            color="success"
            type="button"
            className="whitespace-nowrap min-w-fit"
          />
        </div>
        <PaymentStatusModal
          reGetData={getWalletsTransactions}
          ref={paymentStatusRef}
          transactionData={transactionData}
        />
        <UserReportsFilter filterDataHandler={filterDataHandler} />
        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
        <Table
          columns={walletsTransactionColumns}
          rows={data}
          onCustomFunction={chnagePaymentStatus}
          customFunctionName="ویرایش وضعیت"
          onCustomFunction2={editTransaction}
          customFunctionName2="ویرایش"
        />

        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
      </div>
    </>
  );
}
